import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=a77db328&scoped=true&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77db328",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a77db328')) {
      api.createRecord('a77db328', component.options)
    } else {
      api.reload('a77db328', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=a77db328&scoped=true&", function () {
      api.rerender('a77db328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/notifications/Notifications.vue"
export default component.exports